import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTypedSelector } from 'src/State/RootReducer'
import { setActiveInstallation, setActiveStorage, setInstallation } from 'src/State/Storage/StorageActions'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { fetchInstallation } from 'src/Libs/installations/api/installation.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

/**
 * This hook handles the title and sets storage and installation upon refresh
 * It should be used in the context of installation pages (in essence pages which have an installation id in the url)
 */
export const useInstallationPageHandler = (titleKey: string): void => {
  const refresh = useTypedSelector(state => state.apiView.refresh)
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()
  const authFetch = useAuthFetchWithResponse()

  useEffect(() => {
    dispatch(appUpdate({ title: t(titleKey) }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, titleKey])

  useEffect(() => {
    dispatch(setActiveStorage(storageId))
    if (installationId) {
      dispatch(setActiveInstallation(parseInt(installationId), storageId))
      fetchInstallation(Number(installationId), authFetch).then(res => {
        if (res.value) {
          dispatch(setInstallation(res.value))
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])
}
